<template>
  <div>
    <h1 align="center">Добро пожаловать!</h1>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
